export default __webpack_public_path__ + "static/media/Flawmind Necklace.7dab8d07.jpg";